import { createSlice } from "@reduxjs/toolkit";
import { useGetRegistrationPrices } from '../../Sales/Hooks/index';
import{useGetPrintingMachineType} from '../Hooks/Index'
import uuid from "react-uuid";

import { Typography } from "@mui/material";






const setPriceSelected=(state,action)=>{
    state.priceSelected=[...action.payload]
}

const clearPriceSelected=(state)=>{
    state.priceSelected=[]
}
const clearPriceForSend=(state)=>{
    state.pricesForSend=[];
}













const setSendInfo=(state,action)=>{
state.sendInfo=[...state.sendInfo,action.payload]
}
const clearSendInfo=(state)=>{
    state.sendInfo=[]
}


const clearCoummunicatios=(state)=>{
state.communications=[]
}

const setEditMode=(state)=>{
state.editMode=!state.editMode
}
const deSetEditMode=(state)=>{
    state.editMode=false
}
const setDeleteMode=(state)=>{
 state.deleteMode=true
}

const deSetDeleteMode=(state)=>{
state.deleteMode=false;
}

const setCustomerSelected=(state,action)=>{
    // console.log(state.customerSelected)
  state.customerSelected=action.payload
}

const deletePriceSelected=(state,{payload:id})=>{
 state.priceSelected=state.priceSelected.filter((price)=>{
  return price.id!==id
 })
 state.editModeData.customerPrices.priceSelectedId=state.editModeData.customerPrices.priceSelectedId.filter(item=>item!==id)
}

const deletePriceForSend=(state,action)=>{
// console.log(action.payload,'form reduxxxxxx :))))')
state.pricesForSend=state.pricesForSend.filter((price)=>{
return price.id!==action.payload
})
}

const deleteCommunicationSelected=(state,action)=>{
state.communications=state.communications.filter((communication)=>{
 return communication.id!==action.payload
})
}



const deleteSendInfoSelected=(state,{payload:id})=>{
    // console.log(id)
state.sendInfo=state.sendInfo.filter(sendInfoo=> sendInfoo.id!==id)
}






const setPriceEdited=(state,{payload})=>{
    let{id,value}=payload;
    // console.log(id,value)
    let priceUpdated=state.editModeData.customerPrices.customerPricesDuplicated.map((price)=>{
    if (price.id===id  ) {
        return {...price,price:parseInt(value),type:state.editModeData.customerPrices.AddedPrices.includes(price.klischePriceId)?'edited':'added'}
    }
    return price
    })

    state.editModeData.customerPrices.customerPricesDuplicated=[...priceUpdated]
  

       

}








const setCommunications=(state,action)=>{
    state.communications=[...state.communications,action.payload]
    // console.log(state.communications)
    }

    const setCostumerCommunication=(state,action)=>{
     state.customerCommunication=action.payload
    }
    
    // hazf etelaat az listi ke dar hale namayesh ast
    const deleteItemFromCustomerCommunication=(state,{payload:id})=>{
    state.communications=state.communications.filter((commu)=>commu.id!==id)
   

    }
    
    // ezafe kardan be list dar haale namaysh
    const addNewItemTocustomerCommunication=(state,action)=>{
    state.customerCommunication=[...state.customerCommunication,{...action.payload}]
    }


    
    // ezafe kardan be listi ke baraye ersal ast
    const addToNewCustomerCommunication=(state,action)=>{
       state.newCustomerCommunications=[...state.newCustomerCommunications,action.payload]
    }

    // daryaft sendInfo sabt shode baraye moshtari
    const setCustomerSendInfoRegistred=(state,action)=>{
    state.customerSendInfoRegistred=action.payload
    }
   
    // amade kardan list send info jadid baraye ersal dar halate edit
    const setNewCustomerSendInfoForSend=(state,action)=>{
    state.newCustomerSendInfoForSend=[...state.newCustomerSendInfoForSend,{...action.payload}]
    }

    // update list sendinfo baraye namyesh dar data grid
    const updateSendInfoRegistred=(state,action)=>{
        state.customerSendInfoRegistred=[...state.customerSendInfoRegistred,{...action.payload}]
    }

    //hazf info az send info list dar hardo list
    const deleteSendInfoFromSendInfoList=(state,action)=>{
        state.customerSendInfoRegistred=state.customerSendInfoRegistred.filter((item)=>{
            return item.id!=action.payload
            })
           
            state.newSendInfoForSend=state.newSendInfoForSend.filter((item)=>{
                return item.id!=action.payload
            })
    }
    // pak kardan atalaat
    const clearAddedInfo=(state)=>{
        state.customerSendInfoRegistred=[];
        state.newSendInfoForSend=[];
        state.customerCommunication=[];
        state.newCustomerCommunications=[];
        state.rawValues=[];
        state.machineInfoData.machineInfoList=[]
        state.customerDpi_Lpis=[]
      

    }

    // daryaft id haye gheymat haye daryafte shode
    const setRawValuesID=(state,{payload:ids})=>{    
        // console.log(ids)
        if (state.priceCounter===0) {
            state.rawValuesId=[...ids];
        } else {
          
            state.confirmedValues=[...state.confirmedValues,...ids.filter((item) => !state.rawValuesId.includes(item))];
            state.rawValuesId=[...ids];
   
        }

   

    }



    


//    azafe kardan gheymat bar assaas id az list entekhabi
    const setRawValues=(state,{payload})=>{
    if (state.priceCounter===0) {
        let ids=state.rawValuesId;
        let herperVariable=ids.map((id)=>{           
            let hVar={
            klischePriceId:id,
            price:0,
            date:new Date().toJSON(),
                    }

                    return state.allKlischePrices.find((row)=>{
                                         
                        if (row.id===id  ) {
                           
                            let obj=Object.assign(row,hVar)
                           
                            return obj
                        }
                        
                        })
                  
                  })


                //   console.log(herperVariable)
                  state.rawValues=[...state.rawValues,...herperVariable];
    } else {
        
        let ids=state.confirmedValues;
        let herperVariable=ids.map((id)=>{           
            let hVar={
            klischePriceId:id,
            price:0,
            date:new Date().toJSON(),
                    }

                    return state.allKlischePrices.find((row)=>{
                                         
                        if (row.id===id  ) {
                           
                            let obj=Object.assign(row,hVar)
                           
                            return obj
                        }
                        
                        })
                  
                  })


                //   console.log(herperVariable)
                  state.rawValues=[...state.rawValues,...herperVariable];
                  state.confirmedValues=[]
    }
                
                    
    }
   
    // delete from Selected Values
    const deleteItemValues=(state,{payload:id})=>{
        state.rawValues=state.rawValues.filter((item)=>item.id!==id)
        state.rawValuesId=state.rawValuesId.filter(idd=>idd!==id)
    
    }

    const deletePrices=({editModeData},{payload})=>{
        let{id,klischePriceId}=payload;
        editModeData.customerPrices.customerPricesDuplicated=editModeData.customerPrices.customerPricesDuplicated.filter(price=>price.id!==id)
        editModeData.customerPrices.priceSelectedId=editModeData.customerPrices.priceSelectedId.filter(priceId=>priceId!==klischePriceId)

    }

// در حالت ویرایش
   const setNewDateForPrices=(state,{payload})=>{

   if (state.editMode) {
    let{id,newDate}=payload;
    state.editModeData.newDate=newDate;
    let listUpdated=state.editModeData.customerPrices.customerPricesDuplicated.map((price)=>{
     if (id===price.id) {
         return{...price,date:newDate,type:'edited'}
     }
     return price
    })
    // console.log(listUpdated)
    state.editModeData.customerPrices.customerPricesDuplicated=[...listUpdated]
   } else {
    let{id,newDate}=payload;
    // state.editModeData.newDate=newDate;
    let listUpdated=state.rawValues.map((price)=>{
        if (id===price.id) {
            return{...price,date:newDate}
        }
        return price
       })
       state.rawValues=[...listUpdated]
   }


   }










    const addCounter=(state,action)=>{

    state.addCounter+=1
    
    }

    const reducCounter=(state,action)=>{
    state.addCounter-=1;
    }


    const outRangePrice=()=>{
        return '';
        setTimeout(() => {
            return 0
        }, 2000);
    }



 const setConfirmedValues=(state,{payload})=>{
    let{value:priceValue,dateValue,id}=payload;
   let intPrice=parseInt(priceValue);

     
    state.rawValues=state.rawValues.map((value)=>{
        // console.log(value)
  if (id==value.id) {
    return{...value,klischePriceId:value.id,price:priceValue>=value.minimumPrice && priceValue<=value.maximumPrice?intPrice:1,date:dateValue}
  }
  return value
    })

    
    }







    const setMachineInfo=({machineInfo,keysValue},{payload})=>{
    // console.log(machineInfo,keysValue,payload)
    let{name,value,type,key}=payload


    if (/^\d*\.?\d*$/.test(value)  && type==='number') {
    
        machineInfo=machineInfo[name]=value;
        
      }

      else{
        machineInfo=machineInfo[name]=value;
      }

   
    }

    


    const setCustmerValues=(state,action)=>{
    state.rawValues=action.payload
    }

    const setCylinderInfo=({machineInfo},{payload})=>{
        machineInfo.cylindersInfo=[...machineInfo.cylindersInfo,payload]

        machineInfo.cylindersInfo.cylinderInitialValues={
            aroundCylinder:0,
            gearStep:0,
            numberOfCylinders:0,
            reactionary:0,
            description:''
        }
   
    }

    const filterCylinderInfo=(state,{payload:id})=>{
        if (state.machineInfoData.machineEditFlag) {
            // console.log(id)
            state.machineInfoData.machineSelectedForEdit.cylindersInfo=state.dublicateCylinderAnilux.cylinder.filter(item=>item.id!==id)
        } else {
            state.machineInfo.cylindersInfo=state.machineInfo.cylindersInfo.filter(item=>item.id!==id)
        }
    }
    const filterAddedCylinder=({dublicateCylinderAnilux},{payload:id})=>{
      
        dublicateCylinderAnilux.cylinder=dublicateCylinderAnilux.cylinder.filter(cylinder=>cylinder.id!==id)
    }

    const setOniluxInfo=({machineInfo},{payload:aniluxData})=>{
        machineInfo.aniloxes=[...machineInfo.aniloxes,aniluxData];
        machineInfo.aniloxeInitialValue={
            aniloxType:'',
            lpI_LPC:0,
            volume:0,
            degree:0,
            number:0
        }
    }

    const setMachineDpiLpi=({machineInfo},{payload:DpiLpiData})=>{
      machineInfo.machineDpi_lpi=[...machineInfo.machineDpi_lpi,DpiLpiData]
    }

const setCustomerAccountingList = (state, { payload: AccountingData }) => {
  const { action, item, accountId,items } = AccountingData;

  console.log(AccountingData)

  switch (action) {
    case 'add':
      state.customerAccountingList = [
        ...state.customerAccountingList,
        item,
      ];
      break;

  case 'edit':
  state.customerAccountingList = state.customerAccountingList.map((acc) => {
    if (acc.id === accountId) {
      // داده‌ی جدید رو با قبلی ترکیب کن
      const updatedItem = { ...acc, ...item };

      // اگر storeType وجود داشت و registered بود، تغییرش بده
      if (updatedItem.storeType === 'registred') {
        updatedItem.storeType = 'edited';
      }

      return updatedItem;
    }

    // سایر آیتم‌ها بدون تغییر
    return acc;
  });
  break;


    case 'delete':
      state.customerAccountingList = state.customerAccountingList.filter(
        (acc) => acc.id !== accountId
      );
      break;

    case 'reset':
      state.customerAccountingList = [];
      break;

      case 'set':
      state.customerAccountingList = items;
      break;

    default:
      break;
  }
};

   

    

   
  

    const setViewMachineInfo=(state,{payload})=>{
        let machineInfoObj={
            id:uuid(),
            printingMachineName:state.machineInfo.printingMachineName,
            numberOfColors:state.machineInfo.numberOfColors,
            generalResilience:state.machineInfo.generalResilience,
            printingMachineTypeId:state.keysValue.machineType,
            fitLpi:state.keysValue.fitLpi,
            maximumLpi:state.keysValue.maximumLpi,
            printSide:state.keysValue.printSide,
            generalResilience:state.machineInfo.generalResilience,
            gearStep:state.machineInfo.cylindersInfo[0].gearStep,
            aroundCylinder:state.machineInfo.cylindersInfo[0].aroundCylinder

        }
        state.viewMachinInfo=[...state.viewMachinInfo,machineInfoObj]
       
    // console.log(printingMachineName)
    }

    const setKeysValues=({keysValue},{payload})=>{
    //  state.keysValue=[...state.keysValue,payload];
    let{type,key}=payload;
 
    switch (type) {
        case 1:
            keysValue.machineType=key
            break;
            case 2:
            keysValue.fitLpi=key
            break;
            case 3:
            keysValue.maximumLpi=key
            break;
            case 4:
                keysValue.printSide=key
            break
            

        default:
            break;
    }


    }

//  afzoodane etelaate machine jadid dar halate addddddddddddddddd
    const setMachineInfoList=(state,{payload})=>{
    state.machineInfoData.machineInfoList=[...state.machineInfoData.machineInfoList,{id:uuid(),...state.machineInfo}]

    state.machineInfo={
        cylindersInfo:[],
            aniloxes:[],
            machineDpi_LpiList:[],

            printingMachineName :'',
            numberOfColors:0,
            expertMachine:'',
            generalResilience:0,
            description:'',
            talcWidth:0,
            talcHeight:0,
            choiseChoobakType:'',
            printSide:0,
            printingMachineTypeId:'',
          
            
            
    }

    }





    

    const setMachineSelectedForEdit=(state,{payload})=>{
    // console.log(payload)

    state.machineInfoData.machineSelectedForEdit=payload;
    state.dublicateCylinderAnilux.aniloxes=payload.aniloxes;
    state.dublicateCylinderAnilux.cylinder=payload.cylindersInfo;
    state.dublicateCylinderAnilux.machineDpi_LpiList=payload.machineDpi_LpiList



    }

    const setEditMachineFlag=(state)=>{
         
          
            if (state.machineInfoData.machineEditFlag) {
                state.machineInfoData.machineEditFlag=!state.machineInfoData.machineEditFlag
            }
            else{
                state.machineInfoData.machineEditFlag=!state.machineInfoData.machineEditFlag
            }
          
    }


    

  


    const filterCylinderDublicate=(state,{payload:id})=>{
  if (state.machineInfoData.machineEditFlag) {
    state.machineInfoData.machineSelectedForEdit.cylindersInfo=state.machineInfoData.machineSelectedForEdit.cylindersInfo.filter(cylinder=>cylinder.id!==id) 
  } else {
    state.machineInfo.cylindersInfo=state.machineInfo.cylindersInfo.filter(cylinder=>cylinder.id!==id)
  }  
    }

    const addToCylinderDublicate=(state,{payload})=>{
        // console.log(payload)
         state.machineInfoData.machineSelectedForEdit.cylindersInfo=[...state.machineInfoData.machineSelectedForEdit.cylindersInfo,payload]
    }

    const filterOnilux=(state,{payload:id})=>{
        if (state.machineInfoData.machineEditFlag) {
         
            state.machineInfoData.machineSelectedForEdit.aniloxes=state.machineInfoData.machineSelectedForEdit.aniloxes.filter(anilux=>anilux.id!==id)
          
        } else {
       
            state.machineInfo.aniloxes=state.machineInfo.aniloxes.filter(anilux=>anilux.id!==id)
        }
       }

    const filterAniluxDuplicate=(state,{payload:id})=>{
        if (state.machineInfoData.machineEditFlag) {
           
            state.machineInfoData.machineSelectedForEdit.aniloxes=state.machineInfoData.machineSelectedForEdit.aniloxes.filter(anilux=>anilux.id!==id)
        
        } else {
            // console.log(id)
            state.machineInfo.aniloxes=state.machineInfo.aniloxes.filter(anilux=>anilux.id!==id)
        }

    }


    const filterDpiLpi=(state,{payload:id})=>{

        if (state.machineInfoData.machineEditFlag) {
            // console.log(id)
            state.machineInfoData.machineSelectedForEdit.machineDpi_LpiList=state.machineInfoData.machineSelectedForEdit.machineDpi_LpiList.filter(dpi=>dpi.id!==id)
        } else {
            state.customerDpi_Lpis=state.customerDpi_Lpis.filter(dpiLpi=>dpiLpi.id!==id)
        }
      }
   

    const addToAniluxDuplicate=(state,{payload})=>{
        state.machineInfoData.machineSelectedForEdit.aniloxes=[...state.machineInfoData.machineSelectedForEdit.aniloxes,payload]
    }


    




    const addNewDatatoMachinSelect=(state,{payload:id})=>{
        // let id=state.machineInfoData.machineSelectedForEdit.id;
        state.machineInfoData.machineInfoList=state.machineInfoData.machineInfoList.filter(machine=>machine.id!==id);
        state.machineInfoData.machineInfoList=[...state.machineInfoData.machineInfoList,state.machineInfoData.machineSelectedForEdit]

    }

    const updateMachineSelected=(state,{payload})=>{
    // console.log(payload)
    let{name,value}=payload;
    // console.log(name,value)

    state.machineInfoData.machineSelectedForEdit[name]=value;

    // console.log()
    }

    const clearAllData=(state)=>{
    state.machineInfoData.machineInfoList=[]
    }







    const setSingleCustomerData=(state,{payload})=>{
    
          state.viewMode.singleCustomerData=payload
    }

    const setErrors=(state,{payload})=>{
    // console.log(payload)
    state.errors=payload;
    }

    // ////////////////////////////////////////////////////////////////////////////////////////////   editModeOperation



    const setSingleCustomerDataForEdit=(state,{payload})=>{
      state.editModeData.customerMachineInfo.MachineInfoList=payload.machineInfo;
      state.editModeData.singleCustomerData=payload;
      state.editModeData.customerMachineInfo.customerMachineIds=payload.machineInfo.map(machine=>machine.id)
      state.editModeData.customerPrices.priceSelectedId=payload.customerFinancial.customerPrices.map(price=>price.klischePriceId);
      state.materialPriceSelectionModel=payload.customerFinancial.customerPrices.map(price=>price.klischePriceId);
      state.materialPriceHistoryIds=payload.customerFinancial.customerPrices.map(price=>price.klischeTypeAndThicknessId)

      
      state.editModeData.customerPrices.AddedPrices=payload.customerFinancial.customerPrices.map(price=>price.klischePriceId);
    //   state.editModeData.customerPrices.rawPricesIds=payload.customerFinancial.customerPrices.map(price=>price.klischePriceId)
      state.editModeData.customerPrices.customerPricesDuplicated=payload.customerFinancial.customerPrices;

      state.customerDpi_Lpis=payload.customerDpi_Lpis.map((item)=>({...item,type:'registred'}))
      state.communications=payload.customerCommunications;
      state.sendInfo=payload.customerDeliverInfos

// sale.machineInfo.aniloxe
    }





    const setRawPricesIds=(state,{payload:ids})=>{
        state.editModeData.customerPrices.rawPricesIds=[...state.editModeData.customerPrices.rawPricesIds,...ids.filter((item) => !state.editModeData.customerPrices.priceSelectedId.includes(item))];
        state.editModeData.customerPrices.priceSelectedId=[...state.editModeData.customerPrices.priceSelectedId,...state.editModeData.customerPrices.rawPricesIds]
    }


// ////////////////////////////////////////////////////////////////////////////////////////////////////







 

    const addNewPricesToOldPrices=(state)=>{
        let herperVariable=state.editModeData.customerPrices.rawPricesIds.map((id)=>{           
            let hVar={
            klischePriceId:id,
            price:0,
            date:new Date().toJSON(),
            type:'added'
                    }
                    return state.editModeData.allPrices.find((row)=>{
                                         
                        if (row.id===id  ) {
                           
                            let obj=Object.assign(row,hVar)
                           
                            return obj
                        }
                        
                        })
                  
                  })

                  state.editModeData.customerPrices.customerPricesDuplicated=[...state.editModeData.customerPrices.customerPricesDuplicated,...herperVariable]
                  state.editModeData.customerPrices.rawPricesIds=[]

    }





    const setAllPrices=(state,{payload})=>{
    state.editModeData.allPrices=payload
    }

    const deleteCustomerMachineInfo=({editModeData},{payload:id})=>{
        editModeData.customerMachineInfo.MachineInfoList=editModeData.customerMachineInfo.MachineInfoList.filter(machineInfo=>machineInfo.id!==id)
    }

    const updateMachineInfoList=(state,{payload})=>{

    if (state.machineInfoData.machineEditFlag) {
        let id=state.machineInfoData.machineSelectedForEdit.id;
        state.editModeData.customerMachineInfo.MachineInfoList=state.editModeData.customerMachineInfo.MachineInfoList.filter(machine=>machine.id!==id);
        state.editModeData.customerMachineInfo.MachineInfoList=[...state.editModeData.customerMachineInfo.MachineInfoList,{...state.machineInfoData.machineSelectedForEdit,printSide:state.machineInfoData.machineSelectedForEdit.printSideType,type:'edited'}]
   
      
        state.machineInfoData.machineSelectedForEdit={}
        state.machineInfoData.machineEditFlag=!state.machineInfoData.machineEditFlag
       
    } else {

    
        state.editModeData.customerMachineInfo.MachineInfoList=[...state.editModeData.customerMachineInfo.MachineInfoList,{...state.machineInfo,id:uuid(),printSide:state.machineInfo.printSideType,type:'added'}];
        state.machineInfo={
                cylindersInfo:[],
                aniloxes:[],
                machineDpi_LpiList:[],
                printingMachineName :'',
                numberOfColors:0,
                expertMachine:'',
                generalResilience:0,
                description:'',
                talcWidth:0,
                talcHeight:0,
                choiseChoobakType:'',
                printSide:0,
                printingMachineTypeId:'',
                fitLpiId: "",
                maximumLpiId: "",
                
        }
    }
    }

    const filterMachineInfo=(state,{payload:id})=>{
//   state.priceCounter+=1
    //  console.log(id)
     state.machineInfoData.machineInfoList=state.machineInfoData.machineInfoList.filter(machine=>machine.id!==id)
    }

    const newAddPriceCounter=(state,{payload})=>{
    state.priceCounter+=1
    }
    const resetPriceCounter=(state)=>{
        state.priceCounter=0
    }

//  state.machineInfoData.machineSelectedForEdit.cylindersInfo=[...state.machineInfoData.machineSelectedForEdit.cylindersInfo,payload]
    const setDpiLpi=(state,{payload})=>{
        // console.log(payload);
        let{id}=payload;
        // console.log(id)

        state.customerDpi_Lpis=state.customerDpi_Lpis.filter(item=>item.id!==id)
        state.customerDpi_Lpis=[...state.customerDpi_Lpis,payload]



        // if (state.machineInfoData.machineEditFlag) {
        //     state.machineInfoData.machineSelectedForEdit.machineDpi_LpiList=[...state.machineInfoData.machineSelectedForEdit.machineDpi_LpiList,payload]
        // } else {
        //     state.machineInfo.machineDpi_LpiList=[...state.machineInfo.machineDpi_LpiList,payload]
        // }
        
    }

    const updateLpiDpi=(state,{payload})=>{
        let {id}=payload;
        state.customerDpi_Lpis=state.customerDpi_Lpis.filter(item=>item.id!==id)
        state.customerDpi_Lpis=[...state.customerDpi_Lpis,payload]
    }

  





    // ذخیره همه ی قیمت ها
    const setAllKlischePrices=(state,{payload})=>{
        state.allKlischePrices=[...payload];
   
    }


    const clearAddedData=(state)=>{
   if (state.priceCounter===0) {
    state.rawValuesId=[]
    state.editModeData.customerPrices.priceSelectedId=[];
    state.editModeData.customerPrices.customerPricesDuplicated=[];
    state.customerDpi_Lpis=[];
    state.communications=[];
    state.sendInfo=[]
    // state.materialPriceSelectionModel=[]
   } else {
    
   }
    }
   

    const setPriceSelectedIds=(state,{payload:ids})=>{
    // console.log(ids)
    }
   
    const setMaterialPriceSelectionModel=(state,{payload})=>{
    // console.log(payload)
    state.materialPriceSelectionModel=[...payload]
    }

    const deletePriceSelectedModel=(state,{payload:id})=>{
        state.materialPriceSelectionModel=state.materialPriceSelectionModel.filter(item=>item!==id)
    }

    const clearPriceSelectionModel=(state,{payload})=>{
        state.materialPriceSelectionModel=[]
    }



    // be rooz resanie Selection Model material Selected
const updateMeterialSelectionModel=(state,{payload})=>{
    state.materialPriceSelectionModel=[...state.materialPriceSelectionModel,...payload]
}


// filter kardan  Selection Model material Selected

const filterMaterialPriceSelectionModel=(state,{payload:klischPriceId})=>{
    state.materialPriceSelectionModel=state.materialPriceSelectionModel.filter(item=>item!==klischPriceId)
}



const setCylinderInitialValues=(state,{payload})=>{
    let {name,value,type}=payload;
    state.machineInfo.cylinderInitialValues[name]=type==='number'?parseInt(value):value;
}

const setAniluxesInitialValues=(state,{payload})=>{
    let {name,value,type}=payload;
   // console.log(payload,'payloaddddddddddddddddd')
    state.machineInfo.aniloxeInitialValue[name]=type==='number'?parseInt(value):value;
}

const resetMachineInfo=(state)=>{
    state.machineInfo={
        cylindersInfo:[],
        aniloxes:[],
        printingMachineName :'',
        numberOfColors:0,
        machineExpert:'',
        generalResilience:0,
        description:'',
        talcWidth:0,
        talcHeight:0,
        choiseChoobakType:'',
        printSide:0,
        printingMachineTypeId:'',         
        machineProfileId:"",
        printingMachineType:'',


        cylinderInitialValues:{
            aroundCylinder:0,
            gearStep:0,
            numberOfCylinders:0,
            reactionary:0,
            description:''
        },
        aniloxeInitialValue:{
             aniloxType:'',
             lpI_LPC:0,
             volume:0,
             degree:0,
             number:0
        }
       
       
    }
}

const setGetCustomersBody=(state,{payload})=>{
let{propName,value}=payload;
state.getCustomersBody[propName]=value;
}




const initialState={
    
    editMode:false,
    deleteMode:false,
    priceCounter:0,
    allKlischePrices:[],
    materialPriceSelectionModel:[],
    materialPriceHistoryIds:[],
    
    

    editModeData:{
    singleCustomerData:{},
    allPrices:[],
    customerPrices:{
    priceSelectedId:[],
    customerPricesDuplicated:[],
    rawPricesIds:[],
    AddedPrices:[],
    newDate:new Date().toJSON(),
    
    }
    ,
    customerMachineInfo:{
        customerMachineIds:[],
        MachineInfoList:[]
    }
    ,
    customerCommunications:[],
    customerSendInfo:[]

    }
    ,

    priceSelected:[],
    pricesForSend:[],
    priceEdited:[],
    communications:[],
    customerAccountingList:[],
    customerPrices:[],
    sendInfo:[],
    customerDpi_Lpis:[],
    customerSelected:{},
    newPriceSelected:[],

    customerCommunication:[],


    newCustomerCommunications:[],

    customerSendInfoRegistred:[],
    newCustomerSendInfoForSend:[],

    rawValues:[],
    rawValuesId:[],
    confirmedValues:[],
    addCounter:0,





    keysValue:{
    machineType:'',
    fitLpi:'',
    maximumLpi:'',
    printSide:''
    },

    machineInfo:{
            cylindersInfo:[],
            aniloxes:[],
            printingMachineName :'',
            numberOfColors:0,
            machineExpert:'',
            generalResilience:0,
            description:'',
            talcWidth:0,
            talcHeight:0,
            choiseChoobakType:'',
            printSide:1,
            printingMachineTypeId:'',         
            machineProfileId:"",
            printingMachineType:'',


            cylinderInitialValues:{
                aroundCylinder:0,
                gearStep:0,
                numberOfCylinders:0,
                reactionary:0,
                description:''
            },
            aniloxeInitialValue:{
                 aniloxType:'',
                 lpI_LPC:0,
                 volume:0,
                 degree:0,
                 number:0
            }
           
           
        },
       viewMachinInfo:[],

       machineInfoData:{
        machineInfoList:[],
        machineEditFlag:false,
        machineSelectedForEdit:{}
       }
       ,
       dublicateCylinderAnilux:{
        cylinder:[],
        aniloxes:[],
        machineDpi_LpiList:[]

       }
       ,


       viewMode:{
        singleCustomerData:{},

       }
       ,
       errors:''
       ,

       getCustomersBody:{
        pageSize: 25,
        page: 1,
        searchTerm: "",
        customerFilter:'00000000-0000-0000-0000-000000000000',
        // orderByField: "CreateDate",
        // orderByDescending: false,
        getExcel:false,
       }
       
       
   
    }
    
 
   




const SaleSlice=createSlice({
    name:'Sale',
    initialState,
    reducers:{
        setPriceSelected,
        clearPriceSelected,
        clearPriceForSend,
    
        setCommunications,
        clearCoummunicatios,
        setEditMode,
        deSetEditMode,
        setCustomerSelected,
        setSendInfo,
        clearSendInfo,
        setDeleteMode,
        deSetDeleteMode,
        deletePriceSelected,
        deletePriceForSend,
        deleteCommunicationSelected,
        deleteSendInfoSelected,
        setPriceEdited,

        setCostumerCommunication,
        deleteItemFromCustomerCommunication,
        addNewItemTocustomerCommunication,
        addToNewCustomerCommunication,

        setCustomerSendInfoRegistred,
        setNewCustomerSendInfoForSend,
        updateSendInfoRegistred,
        deleteSendInfoFromSendInfoList,
        clearAddedInfo,
        



        setRawValuesID,
        setRawValues,
        deleteItemValues,
        setConfirmedValues,
        setCustmerValues,
        addCounter,
        reducCounter,

        setMachineInfo,
        setCylinderInfo,
        filterCylinderInfo,
        setOniluxInfo,
        filterOnilux,
        setViewMachineInfo,
        setKeysValues,
       
        setMachineInfoList,
        setMachineSelectedForEdit,
        setEditMachineFlag,
        updateMachineSelected,
       






        filterCylinderDublicate,
        addToCylinderDublicate,
        filterAniluxDuplicate,
        addToAniluxDuplicate,
        addNewDatatoMachinSelect,
        clearAllData,


        setSingleCustomerData,
        setErrors,



        setSingleCustomerDataForEdit,
        setRawPricesIds,
        addNewPricesToOldPrices,
        setAllPrices,
        deletePrices,
        setNewDateForPrices,
        deleteCustomerMachineInfo,
        updateMachineInfoList,
        newAddPriceCounter,
        resetPriceCounter,
        filterMachineInfo,
        filterAddedCylinder,
        setDpiLpi,
        updateLpiDpi,
        filterDpiLpi,
        setAllKlischePrices,
        clearAddedData,
        setMaterialPriceSelectionModel,
        deletePriceSelectedModel,
        updateMeterialSelectionModel,
        filterMaterialPriceSelectionModel,
        clearPriceSelectionModel,


        // 
        setCylinderInitialValues,
        setAniluxesInitialValues,
        resetMachineInfo,
        setGetCustomersBody,
        setCustomerAccountingList
        
        
     


        
        

        

    }
})


    export const { 

    changeValue:changeValueZero,
    setPriceSelected:setPriceSelectedR,
    clearPriceSelected:clearPriceSelectedR,
    clearPriceForSend:clearPriceForSendR,
    setCommunications:setCommunicationsR,
    clearCoummunicatios:clearCoummunicatiosR,
    setEditMode:setEditModeR,
    deSetEditMode:deSetEditModeR,
    setCustomerSelected:setCustomerSelectedR,
    setSendInfo:setSendInfoR,
    clearSendInfo:clearSendInfoR,
    setDeleteMode:setDeleteModeR,
    deSetDeleteMode:deSetDeleteModeR,
    deletePriceSelected:deletePriceSelectedR,
    deletePriceForSend:deletePriceForSendR,
    deleteCommunicationSelected:deleteCommunicationSelectedR,
    deleteSendInfoSelected:deleteSendInfoSelectedR,
    setPriceEdited:setPriceEditedR,
    setNewPriceSelected:setNewPriceSelectedR,

    setCostumerCommunication:setCostumerCommunicationR,
    deleteItemFromCustomerCommunication:deleteItemFromCustomerCommunicationR,
    addNewItemTocustomerCommunication:addNewItemTocustomerCommunicationR,
    addToNewCustomerCommunication:addToNewCustomerCommunicationR,
    filterAddedCylinder:filterAddedCylinderR,



    setCustomerSendInfoRegistred:setCustomerSendInfoRegistredR,
    setNewCustomerSendInfoForSend:setNewCustomerSendInfoForSendR,
    updateSendInfoRegistred:updateSendInfoRegistredR,
    deleteSendInfoFromSendInfoList:deleteSendInfoFromSendInfoListR,


    clearAddedInfo:clearAddedInfoR,


    setRawValuesID:setRawValuesIDR,
    setRawValues:setRawValuesR,
    deleteItemValues:deleteItemValuesR,
    addCounter:addCounterR,
    setConfirmedValues:setConfirmedValuesR,
    reducCounter:reducCounterR,
    setPriceFiltred:setPriceFiltredR,
    setCustmerValues:setCustmerValuesR,
    
    setMachineInfo:setMachineInfoR,
    setCylinderInfo:setCylinderInfoR,
    filterCylinderInfo:filterCylinderInfoR,
    setOniluxInfo:setOniluxInfoR,
    filterOnilux:filterOniluxR,
    setViewMachineInfo:setViewMachineInfoR,
    setKeysValues:setKeysValuesR,
    setMachineInfoList:setMachineInfoListR,
    setMachineSelectedForEdit:setMachineSelectedForEditR,
    setEditMachineFlag:setEditMachineFlagR,
    updateMachineSelected:updateMachineSelectedR,





    filterCylinderDublicate:filterCylinderDublicateR,
    addToCylinderDublicate:addToCylinderDublicateR,
    addNewDatatoMachinSelect:addNewDatatoMachinSelectR,
    filterAniluxDuplicate:filterAniluxDuplicateR,
    addToAniluxDuplicate:addToAniluxDuplicateR,
    clearAllData:clearAllDataR
    ,

    setSingleCustomerData:setSingleCustomerDataR,
    setErrors:setErrorsR,




    setSingleCustomerDataForEdit:setSingleCustomerDataForEditR,
    setRawPricesIds:setRawPricesIdsR,
    addNewPricesToOldPrices:addNewPricesToOldPricesR,
    setAllPrices:setAllPricesR,
    deletePrices:deletePricesR,
    setNewDateForPrices:setNewDateForPricesR,
    deleteCustomerMachineInfo:deleteCustomerMachineInfoR,
    updateMachineInfoList:updateMachineInfoListR,
    newAddPriceCounter:newAddPriceCounterR,
    resetPriceCounter:resetPriceCounterR,
    filterMachineInfo:filterMachineInfoR,
    setDpiLpi:setDpiLpiR,
    filterDpiLpi:filterDpiLpiR,
    updateLpiDpi:updateLpiDpiR,
    setAllKlischePrices:setAllKlischePricesR,
    clearAddedData:clearAddedDataR,
    setMaterialPriceSelectionModel:setMaterialPriceSelectionModelR,
    deletePriceSelectedModel:deletePriceSelectedModelR,
    clearPriceSelectionModel:clearPriceSelectionModelR,
    updateMeterialSelectionModel:updateMeterialSelectionModelR,
    filterMaterialPriceSelectionModel:filterMaterialPriceSelectionModelR,

    

    


    setCylinderInitialValues:setCylinderInitialValuesR,
    setAniluxesInitialValues:setAniluxesInitialValuesR,
    resetMachineInfo:resetMachineInfoR,
    setGetCustomersBody:setGetCustomersBodyR,
    setCustomerAccountingList:setCustomerAccountingListR

     
    

     }=SaleSlice.actions

     export default SaleSlice.reducer